module.exports = __webpack_public_path__ + "img/listo.342a91af.svg";